import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '@state/index';
import { AdminLayout, ClientLayout } from '@layouts/index';
import { LoginPage, AcceptInvitationPage, AdminDashboard, AdminPrototypesPage, AdminUsersPage, ClientDashboard, } from '@pages/index';
import { PrivateRoute } from './PrivateRoute';
import { AdminRoute } from './AdminRoute';
function RootRedirect() {
    const { user } = useAuth();
    if (!user) {
        return _jsx(Navigate, { to: "/login", replace: true });
    }
    if (user.role === 'admin') {
        return _jsx(Navigate, { to: "/admin", replace: true });
    }
    return _jsx(Navigate, { to: "/dashboard", replace: true });
}
function AdminLayoutWrapper() {
    const { user, logout } = useAuth();
    return _jsx(AdminLayout, { onLogout: logout, userName: user?.name });
}
function ClientLayoutWrapper() {
    const { user, logout } = useAuth();
    return _jsx(ClientLayout, { onLogout: logout, userName: user?.name });
}
export function AppRouter() {
    return (_jsx(BrowserRouter, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/login", element: _jsx(LoginPage, {}) }), _jsx(Route, { path: "/accept-invitation", element: _jsx(AcceptInvitationPage, {}) }), _jsx(Route, { path: "/", element: _jsx(PrivateRoute, { children: _jsx(RootRedirect, {}) }) }), _jsxs(Route, { path: "/admin", element: _jsx(PrivateRoute, { children: _jsx(AdminRoute, { children: _jsx(AdminLayoutWrapper, {}) }) }), children: [_jsx(Route, { index: true, element: _jsx(AdminDashboard, {}) }), _jsx(Route, { path: "prototypes", element: _jsx(AdminPrototypesPage, {}) }), _jsx(Route, { path: "users", element: _jsx(AdminUsersPage, {}) }), _jsx(Route, { path: "settings", element: _jsx("div", { children: "Settings (Coming Soon)" }) })] }), _jsx(Route, { path: "/dashboard", element: _jsx(PrivateRoute, { children: _jsx(ClientLayoutWrapper, {}) }), children: _jsx(Route, { index: true, element: _jsx(ClientDashboard, {}) }) }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/", replace: true }) })] }) }));
}
